
import { Box, Button, Flex, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import 'animate.css';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WalletHistoryArr } from "../../../models/userbio.model";
import routes from "../../../pages/routes";
import { getLocalUserProfile, getUserWallet } from "../../../services/auth.service";
import userService from "../../../services/user.service";
import { getFullDate, getFullTime } from "../../../utils/classOfDegree";
import DashboardHeader from "../../common/DashboardHeader";

const WalletHistory = () => {
    const navigate = useNavigate();
    const [histories, setHistory] = useState<WalletHistoryArr[]>()
    useEffect(() => {
        const user = getLocalUserProfile();
        if (user) {
            getUserWallet(user.uuid).then(
                (res) => {
                    if (res) {
                        userService.getUserWalletHistory(res.uuid)
                            .then((response) => {
                                setHistory(response.data)
                                
                            })
                            .catch((err) => err)
                    }
                }
            )
        }
    }, [])

    return (
        <>
            <DashboardHeader />
            <Flex justifyContent="center" alignItems={'center'} bg='#F9F8F8' height='95vh'>
                <Box bgColor={'white'} width={'80%'} minHeight={'32rem'} height={'auto'} borderRadius={'10px'} boxShadow={'0px 0px 4.307692527770996px 0px rgba(0, 0, 0, 0.15)'} padding={'48px 58px'}>
                    <Flex justifyContent={'space-between'}>
                        <Text fontFamily='Manrope' fontSize='28px' fontWeight={'600'} lineHeight={'130%'}>My Wallet</Text>
                        <Button colorScheme="red" onClick={() => navigate(routes.FundWallet)}>Fund Wallet</Button>
                    </Flex>
                    <Box bgColor={'white'} width={'100%'} minHeight={'10rem'} height={'auto'} borderRadius={'6px solid #353535'} padding={'1rem'} marginTop={'2rem'}>
                        <Text fontFamily='Manrope' color='#353535' fontSize='20px' fontWeight={'600'}>Transactions History</Text>
                        <TableContainer>
                            <Table variant='simple'>
                                <Thead>
                                    <Tr>
                                        <Th>Date</Th>
                                        <Th>Time</Th>
                                        <Th>Amount(N)</Th>
                                        <Th>Type</Th>
                                        <Th>Status</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        histories?.map((transaction, index:number) => {
                                            return (
                                                <Tr key={index}>
                                                    <Td>{getFullDate(transaction.created_at)}</Td>
                                                    <Td>{getFullTime(transaction.created_at)}</Td>
                                                    <Td>{transaction.amount}</Td>
                                                    <Td>{transaction.trans_type}</Td>
                                                    <Td>
                                                        {
                                                            transaction.status === 2 ? ('Successful') : ('Failed')
                                                        }
                                                    </Td>
                                                </Tr>
                                            )
                                        })
                                    }

                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </Flex>

        </>
    );
};

export default WalletHistory;